import React from "react";
import { useSelector } from "react-redux";
import { AccessibilityPopup } from '@skillz/accessibility';
import classes from "./BottomPopup.module.css";

const BottomPopup = ({ children, onClose, title, icon }) => {

    const { texts } = useSelector(state => state.translate);

    return (
        <AccessibilityPopup accessibilityDescription={texts.myProfile} close={onClose}>
            <div className={classes.Overlay} onClick={onClose}>
                <div
                    className={classes.Container}
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className={classes.LineOpenWrap} onClick={onClose} >
                        <div className={classes.LineOpen} ></div>
                    </div>
                    {onClose && title && <div className={classes.Header}>
                        {/* {onClose && <AccessibilityButton className={classes.BtnClose} onClick={onClose} accessibilityDescription={texts.close}><Arrow direction="right" /></AccessibilityButton>} */}
                        <div className={classes.UserImage}>{icon && icon}</div>
                        {<h2 className={classes.Title}>{title}</h2>}
                    </div>}
                    {children}
                </div>
            </div>
        </AccessibilityPopup>
    );
};

export default BottomPopup;
